import { ClockOverlayConfig, DEFAULT_CLOCK_OVERLAY } from "@shared/types";
import { formatTime } from "@/lib/clock";
import { useNow, useWeather } from "@/hooks/useClock";

/** A small, persistent clock (and optional weather) pinned to the bottom-right
 *  corner of the kiosk, shown over the playlist. */
export function ClockOverlay({ config }: { config?: ClockOverlayConfig }) {
  const cfg = config ?? DEFAULT_CLOCK_OVERLAY;
  const now = useNow();
  const weather = useWeather(cfg);
  if (!cfg.enabled) return null;

  const date = cfg.showDate
    ? now.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })
    : null;

  return (
    <div className="pointer-events-none absolute bottom-4 right-4 z-20 rounded-lg bg-black/55 px-4 py-2 text-right text-white backdrop-blur">
      <div className="text-3xl font-semibold leading-tight tabular-nums">
        {formatTime(now, cfg.hour24, cfg.showSeconds)}
      </div>
      {date && <div className="text-sm opacity-80">{date}</div>}
      {cfg.showWeather && weather && (
        <div className="mt-0.5 text-sm opacity-90">
          {weather.emoji} {weather.temp}°{cfg.tempUnit}
          {cfg.locationName ? ` · ${cfg.locationName}` : ""}
        </div>
      )}
    </div>
  );
}
